import React from "react";
import { Edit } from "lucide-react";

interface Diagnosis {
  condition?: string;
  icd_10?: string;
  subtype?: string;
  stage?: string;
  date_of_diagnosis?: string;
  prognostic_score?: string;
  treatment_intent?: string;
}

interface PatientType {
  diagnosis?: Diagnosis;
  createdAt?: string;
  updatedAt?: string;
}

interface ClinicalSummaryProps {
  patient: PatientType;
  openEditDiagnosisModal: () => void;
}

const ClinicalSummary: React.FC<ClinicalSummaryProps> = ({
  patient,
  openEditDiagnosisModal,
}) => {
  return (
    <div className="space-y-6">
      <div className="card relative">

        {/* Edit Button */}
        <button
          onClick={openEditDiagnosisModal}
          className="absolute top-3 right-3 btn-secondary flex items-center space-x-2"
        >
          <Edit className="h-4 w-4" />
          <span>Edit</span>
        </button>

        {/* Heading */}
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Clinical Summary
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

          {/* Diagnosis Section */}
          <div>
            <h4 className="font-medium text-gray-900 mb-2">Diagnosis</h4>

            {patient.diagnosis ? (
              <div className="space-y-1 text-sm text-gray-600">
                <p><strong>Condition:</strong> {patient.diagnosis.condition || "-"}</p>
                <p><strong>ICD-10:</strong> {patient.diagnosis.icd_10 || "-"}</p>
                <p><strong>Subtype:</strong> {patient.diagnosis.subtype || "-"}</p>
                <p><strong>Stage:</strong> {patient.diagnosis.stage || "-"}</p>
                <p><strong>Date of Diagnosis:</strong> {patient.diagnosis.date_of_diagnosis || "-"}</p>
                <p><strong>Prognostic Score:</strong> {patient.diagnosis.prognostic_score || "-"}</p>
                <p><strong>Treatment Intent:</strong> {patient.diagnosis.treatment_intent || "-"}</p>
              </div>
            ) : (
              <p className="text-sm text-gray-500">
                No diagnosis information available
              </p>
            )}
          </div>

          {/* Patient Details Section */}
          <div>
            <h4 className="font-medium text-gray-900 mb-2">Patient Details</h4>
            <div className="space-y-1 text-sm text-gray-600">
              <p>
                <strong>Created:</strong>{" "}
                {patient.createdAt
                  ? new Date(patient.createdAt).toLocaleDateString()
                  : "-"}
              </p>
              <p>
                <strong>Last Updated:</strong>{" "}
                {patient.updatedAt
                  ? new Date(patient.updatedAt).toLocaleDateString()
                  : "-"}
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ClinicalSummary;
